import * as React from "react";
import * as ToastPrimitives from "@radix-ui/react-toast";

export type ToastStatus = "success" | "error" | "info";

interface ToastProps {
	id: string;
	title: string;
	description?: string;
	status: ToastStatus;
	duration?: number;
}

const Toast = React.forwardRef<
	React.ElementRef<typeof ToastPrimitives.Root>,
	React.ComponentPropsWithoutRef<typeof ToastPrimitives.Root> & {
		status: ToastStatus;
	}
>(({ className = "", ...props }, ref) => {
	return (
		<ToastPrimitives.Root
			ref={ref}
			className={`
				toast-animate group pointer-events-auto relative flex items-center gap-3
				rounded-lg bg-gray-900 px-4 py-3 shadow-lg
				${className}
			`}
			{...props}
		/>
	);
});
Toast.displayName = ToastPrimitives.Root.displayName;

const ToastClose = React.forwardRef<React.ElementRef<typeof ToastPrimitives.Close>, React.ComponentPropsWithoutRef<typeof ToastPrimitives.Close>>(({ className = "", ...props }, ref) => (
	<ToastPrimitives.Close
		ref={ref}
		className={`
			rounded p-0.5 text-gray-400 transition-colors hover:text-white
			focus:outline-none focus:ring-1 focus:ring-white/20
			${className}
		`}
		toast-close=""
		{...props}
	>
		<svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
		</svg>
	</ToastPrimitives.Close>
));
ToastClose.displayName = ToastPrimitives.Close.displayName;

const ToastTitle = React.forwardRef<React.ElementRef<typeof ToastPrimitives.Title>, React.ComponentPropsWithoutRef<typeof ToastPrimitives.Title>>(({ className = "", ...props }, ref) => (
	<ToastPrimitives.Title ref={ref} className={`text-sm font-medium text-white ${className}`} {...props} />
));
ToastTitle.displayName = ToastPrimitives.Title.displayName;

const ToastDescription = React.forwardRef<React.ElementRef<typeof ToastPrimitives.Description>, React.ComponentPropsWithoutRef<typeof ToastPrimitives.Description>>(
	({ className = "", ...props }, ref) => <ToastPrimitives.Description ref={ref} className={`text-sm text-gray-400 ${className}`} {...props} />,
);
ToastDescription.displayName = ToastPrimitives.Description.displayName;

export { type ToastProps, ToastPrimitives, Toast, ToastClose, ToastTitle, ToastDescription };
